import type { EndpointStats } from '../../types';

export const ENDPOINT_PROVIDER_LABEL: Record<EndpointStats['provider'], string> = {
  fal: 'fal',
  gemini: 'gemini',
  self_hosted: 'internal',
};

export function shortenEndpoint(endpoint: string, provider: EndpointStats['provider']): string {
  const name = endpoint.replace(/^fal-ai\//, '').replace(/-preview$/, '');
  return `${ENDPOINT_PROVIDER_LABEL[provider]}: ${name}`;
}
